import React from 'react';
import SimpleModal from './SimpleModal';
import styles from './WikiCategoriesManager.module.css';

const WikiCategoryFormModal = ({
  isOpen,
  isEdit,
  formData,
  onFormChange,
  parentOptions = [],
  error,
  saving,
  onClose,
  onSave,
}) => {
  if (!isOpen) return null;

  return (
    <SimpleModal
      title={isEdit ? 'Редактировать категорию' : 'Создать категорию'}
      onClose={onClose}
    >
      {error && <div className={styles.errorMessage}>{error}</div>}
      <div className={styles.form}>
        <div className={styles.formRow}>
          <label className={styles.label}>Родительская категория</label>
          <select
            value={formData.parentId ?? ''}
            onChange={(e) => {
              const v = e.target.value;
              onFormChange({ ...formData, parentId: v === '' ? null : Number(v) });
            }}
            className={styles.select}
          >
            <option value="">— Корневая —</option>
            {parentOptions.map((opt) => (
              <option key={opt.id} value={opt.id}>
                {opt.name}
              </option>
            ))}
          </select>
        </div>
        {!isEdit && (
          <div className={styles.formRow}>
            <label className={styles.label}>ID категории</label>
            <input
              type="text"
              value={formData.id != null ? String(formData.id) : ''}
              onChange={(e) => onFormChange({ ...formData, id: e.target.value })}
              placeholder="guides"
              className={styles.input}
            />
          </div>
        )}
        <div className={styles.formRow}>
          <label className={styles.label}>Название</label>
            <input
              type="text"
              value={formData.name != null ? String(formData.name) : ''}
              onChange={(e) => onFormChange({ ...formData, name: e.target.value })}
            placeholder="Гайды"
            className={styles.input}
          />
        </div>
      </div>
      <div className={styles.modalActions}>
        <button type="button" className={styles.secondaryButton} onClick={onClose}>
          Отмена
        </button>
        <button
          type="button"
          className={styles.primaryButton}
          onClick={onSave}
          disabled={saving}
        >
          {saving ? 'Сохранение...' : isEdit ? 'Сохранить' : 'Создать'}
        </button>
      </div>
    </SimpleModal>
  );
};

export default WikiCategoryFormModal;
